import React, { useMemo, useState } from 'react';
import spellCatalog from '../../../data/spells';
import { ChoiceDetail, spellDetail } from '../components/LevelOneChoices';
import SpellChoiceTile from '../components/SpellChoiceTile';
import { getSpellbook, getWizardLevel, isSpellbookSpell, spellbookProblem, spellbookRoom } from '../../../shared/rules/wizard.mjs';

/**
 * The spells a Wizard's new level adds to the spellbook, chosen in the level-up window through each spell's details.
 * Optional: anything left is added on the Spellcasting card. `onChange` reports the chosen ids.
 */
export default function LevelUpSpellbookChoice({ nextForm, picks, onChange }) {
  const [viewing, setViewing] = useState(null);
  const book = useMemo(() => getSpellbook(nextForm) || [], [nextForm]);
  const level = getWizardLevel(nextForm);
  const room = spellbookRoom(nextForm, book, spellCatalog);
  const open = Math.max(0, room.total - room.used);
  const offered = useMemo(() => Object.entries(spellCatalog).map(([spellId, spell]) => ({ ...spell, spellId }))
    .filter((spell) => isSpellbookSpell(spell, level) && !book.includes(spell.spellId))
    .sort((a, b) => Number(a.level) - Number(b.level) || String(a.name).localeCompare(String(b.name))), [book, level]);
  const levels = [...new Set(offered.map((spell) => Number(spell.level)))];
  const viewed = viewing && offered.find((spell) => spell.spellId === viewing);
  const problem = picks.length ? spellbookProblem(nextForm, [...book, ...picks], spellCatalog) : '';
  return <div className="levelup-choice" role="group" aria-label="Spellbook">
    <span className="form-label">Spellbook · {picks.length} of {open}</span>
    <p className="levelup-choice__hint">Choose the spells this level adds. Optional now: you can also add them on the Spellcasting card in Character Features.</p>
    {levels.map((spellLevel) => <div key={spellLevel} className="mb-2" role="group" aria-label={`Level ${spellLevel} spells`}>
      <strong className="d-block mb-1">Level {spellLevel}</strong>
      <div className="levelup-spell-tiles">{offered.filter((spell) => Number(spell.level) === spellLevel).map((spell) => (
        <SpellChoiceTile key={spell.spellId} spell={spell} selected={picks.includes(spell.spellId)} onClick={() => setViewing(spell.spellId)} />
      ))}</div>
    </div>)}
    {problem && <p className="text-danger small" role="alert">{problem}</p>}
    {viewed && <ChoiceDetail detail={spellDetail(viewed)} selected={picks.includes(viewing)} full={picks.length >= open} onClose={() => setViewing(null)}
      onConfirm={() => { onChange(picks.includes(viewing) ? picks.filter((id) => id !== viewing) : [...picks, viewing]); setViewing(null); }}/>}
  </div>;
}
